import { Component, EventEmitter, Input, OnChanges, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { LocalStorageHelpers } from 'app/helpers';
import { DigitalCareerDaysService } from 'app/services/digital-career-days.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { of } from 'rxjs';
import * as moment from 'moment';
import { CareerDayAvailability } from 'app/interfaces';

@Component({
  selector: 'app-schedule-interview',
  templateUrl: './schedule-interview.component.html',
  styleUrls: ['./schedule-interview.component.scss']
})
export class ScheduleInterviewComponent implements OnInit, OnChanges {
  @Input() interview: any = null;
  @Input() applicationId: number = null;
  @Input() candidate: any = null;
  @Input() careerDayId: number = null;
  @Input() jobTitle: string = null;
  @Input() jobType: string = null;
  @Input() disabled = false;

  @Output() changes: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('modalSchedule') public templateRef: TemplateRef<any>;

  public modalRef: BsModalRef;
  public invitationSent = false;
  public completedAvailability: CareerDayAvailability = {
    user_completed_availability: false,
    team_completed_availability: false
  }

  constructor(
    private dcds: DigitalCareerDaysService,
    private toasterService: ToasterService,
    private localStorageHelper: LocalStorageHelpers,
    private modalService: BsModalService
  ) { }

  get canShow(): boolean {
    return this.applicationId && this.careerDayId && this.candidate;
  }

  public isFinished(date) {
    return moment().diff(date) > 0;
  }

  ngOnInit() {
    // console.log(this.interview, this.applicationId, this.careerDayId, this.candidate);
    // console.log(this.jobType);
  }

  ngOnChanges() {
    // console.log(this.interview, this.applicationId, this.careerDayId, this.candidate);
    // console.log(this.disabled);
  }

  successToast(name: string, surname: string) {
    this.toasterService.pop('success', 'Success', `The interview request with ${name} ${surname} has been successfully completed`);
  }

  errorToast() {
    this.toasterService.pop('error', 'Error!', 'Please try again.');
  }

  openModal(skipModal = false) {
    this.completedAvailability = {
      user_completed_availability: false,
      team_completed_availability: false
    };
    this.dcds.getAvailability(this.careerDayId).subscribe((response) => {
      this.completedAvailability = response;
      if (!skipModal) {
        this.modalRef = this.modalService.show(this.templateRef, { 'class': 'modal-lg' });
      }
    }, (error) => {
      console.log(error);
    });
  }

  scheduleInterview(withTeam: boolean = false) {
    const ob$ = this.dcds.postScheduleInterview(this.careerDayId, this.applicationId, {
      recruiters: withTeam ? [] : [JSON.parse(this.localStorageHelper.get('userData')).id]
      // ,employers_id: JSON.parse(this.localStorageHelper.get('userData')).Teams[0].employers_id
    });

    // FIX-ME only used for testing
    // ob$ = of(withTeam);

    ob$.subscribe(() => {
      // this.successToast(this.candidate.name, this.candidate.surname);
      // this.modalRef.hide();
      this.changes.emit();
      this.invitationSent = true;
    }, (error) => {
      this.errorToast();
      console.log(error);
    });
  }
}
